module.exports = __webpack_public_path__ + "img/yujiaxue.258f1e8b.png";